export class Status
{
    ////Order Status
    public STATUS_INQUIRES: string = "Inquires";
    public STATUS_ACCEPTED_BY_DESIGNER: string = "Accepted_by_designer";
    public STATUS_CONFIRM_BY_DESIGNER: string = "Confirm_by_designer";
    public STATUS_REJECTED_BY_DESIGNER: string = "Rejected_by_designer";
    
    public STATUS_INQUIRES_by_ME: string = "Inquires_by_ME";
    public STATUS_ACCEPTED_by_ME: string = "Accepted_by_ME";
    public STATUS_CONFIRM_by_ME: string = "Confirm_by_ME";
    public STATUS_REJECTED_by_ME: string = "Rejected_by_ME";
    
    
    ////Payment Status
    public FULLY_PAID: string = "Fully Paid";
    public PARTIALLY_PAID: string = "Partially Paid";
    public ON_CREDIT: string = "Credit";

}